<template>
  <div :class="['vmp-product', isWatch ? '' : 'vmp-product-send']">
    <PcProductList
      @openDetails="showDetailDialog"
      :isSubscribe="isSubscribe"
      :clientType="isWatch ? '' : 'send'"
      ref="productList"
      :isCanPush="isCanPush"
      :hasPermission="hasPermission"
      @showProductTab="showProductVisible"
      @openOrder="handleBuy"
      :webinarId="webinarId"
      :liveUrl="webinarUrl"
      :embedClientVideoUrl="embedClientVideoUrl"
      :middleUrl="middleUrl"
      :phone="phone"
      :userCenterUrl="userCenterUrl"
      :btnBuyText="btnBuyText"
      :showCoupon="showCoupon"
      :enableDirectView="enableDirectView"
      :reportData="reportData"
      :pushNum.sync="push_show_num"
    ></PcProductList>
  </div>
</template>
<script>
  import { useRoomBaseServer, useMsgServer, useChatServer, useGoodServer } from 'middle-domain';
  import {
    boxEventOpitons,
    addParamsToUrl,
    isWxMini,
    isWechat,
    appendQueryParamsToPath
  } from '@/app-shared/utils/tool.js';
  import { PcProductList } from '@vhcl/product';
  import { openHref } from '@/app-shared/utils/common.js';
  import { localEventData } from '@/app-shared/cms-data';
  import tidCenter from '@/app-shared/utils/tidCenter.js';

  export default {
    name: 'VmpProductPcList',
    data() {
      return {
        goodsList: [],
        tokenId: '',
        push_show_num: 1
      };
    },
    components: {
      PcProductList
    },
    computed: {
      webinarId() {
        return this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.id;
      },
      isWatch() {
        return !['send', 'record', 'clientEmbed'].includes(this.roomBaseServer.state.clientType);
      },
      isSubscribe() {
        return this.$domainStore.state.roomBaseServer.watchInitData.status === 'subscribe';
      },
      userId() {
        return this.roomBaseServer.state.watchInitData.join_info.third_party_user_id;
      },
      doc_permission() {
        return this.roomBaseServer.state.interactToolStatus.doc_permission;
      },
      // 发起端通过配置控制是否展示商品tab
      hasPermission() {
        return !!this.$domainStore.state.roomBaseServer.configList.product_show;
      },
      // 是否有推送商品的权限
      isCanPush() {
        // 观看端没有权限
        if (this.isWatch) return false;
        // 主持人有权限
        if (this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name == 1)
          return true;
        // 嘉宾是主讲人的时候或者助理，由配置决定是否有权限
        if (
          (this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name == 4 &&
            this.doc_permission == this.userId) ||
          this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name == 3
        ) {
          return this.hasPermission;
        }
        // 其余情况没权限
        return false;
      },
      isEmbed() {
        // 判断完全嵌入
        const { embedObj } = this.roomBaseServer.state;
        return embedObj.embed && !embedObj.embedVideo;
      },
      permissionValueObj() {
        return this.$domainStore.state.roomBaseServer.permissionValueObj;
      },
      middleUrl() {
        // youzan.jump_url   中间页链接
        return this.permissionValueObj['youzan.jump_url'] || '';
      },
      userCenterUrl() {
        // youzan.user_center_url 用户中心链接
        return this.permissionValueObj['youzan.user_center_url'] || '';
      },
      phone() {
        return this.$domainStore.state?.roomBaseServer?.watchInitData?.join_info?.phone;
      },
      embedClientVideoUrl() {
        return '';
      },
      // 是否是cms嵌入
      isCms() {
        return this.$domainStore.state.roomBaseServer.isCms == 1;
      },
      webinarUrl() {
        if (this.isCms) {
          const queryData = localEventData();
          return queryData.parentUrl || '';
        }
        return location.href; // 当前商品所在活动地址
      },
      webinarType() {
        //活动信息 1-直播中，2-预约，3-结束，4-点播，5-回放
        return Number(this.$domainStore.state.roomBaseServer.watchInitData.webinar.type);
      },
      // 购买按钮文案
      btnBuyText() {
        return this.$domainStore.state.goodServer?.btnBuyText;
      },
      // 是否展示优惠券入口
      showCoupon() {
        return this.$domainStore.state.goodServer?.showCoupon;
      },
      enableDirectView() {
        return this.$domainStore.state.goodServer?.enable_direct_view;
      },
      reportData() {
        if (this.isWatch) {
          // 观看端才上报
          return {
            business_uid:
              this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.userinfo?.user_id,
            webinar_id: this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id,
            user_id: this.$domainStore.state.roomBaseServer?.watchInitData?.join_info?.user_id,
            third_user_id:
              this.$domainStore.state.roomBaseServer?.watchInitData?.join_info?.third_party_user_id,
            visitor_id: this.$domainStore.state.roomBaseServer?.watchInitData?.visitor_id,
            user_name: this.$domainStore.state.roomBaseServer?.watchInitData?.join_info?.nickname
          };
        }
        return undefined;
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();

      // 初始化 购买按钮自定义文案
      useGoodServer()
        .getProductsOtherInfo()
        .then(res => {
          this.push_show_num = res?.data?.push_show_num;
        });
    },
    created() {
      if (this.isWatch) {
        //发起端也使用了此组件，要限制观看端才调用
        tidCenter.getTid(this.webinarId).then(tokenId => {
          this.tokenId = tokenId;
        });
      }
    },
    mounted() {
      // 更新商品列表
      useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
        let temp = Object.assign({}, rawMsg);

        if (typeof temp.data !== 'object') {
          temp.data = JSON.parse(temp.data);
          temp.context = JSON.parse(temp.context);
        }
        const { type = '' } = temp.data || {};
        switch (type) {
          case 'goods_update_info':
            this.updateGoodsList(temp);
            break;
          case 'push_goods_change':
            this.updateGoodsList(temp);
            this.addPushMsg(temp);
            break;
          case 'hot_sale':
            this.$refs.productList.updateHotSale(temp.data.sales);
            break;
        }
      });
    },
    methods: {
      /**
       * 显示商品详情
       */
      showDetailDialog(goodsItem) {
        const data = goodsItem;
        if (
          this.$domainStore.state.goodServer?.enable_direct_view &&
          (data.buy_type == 2 || data.buy_type == 4)
        ) {
          data.covered_status != 1 && this.handleBuy(goodsItem);
          return;
        }
        // 数据埋点
        window.vhallReportForWatch?.report(170029, {
          goods_id: goodsItem.goods_id,
          goods_name: encodeURIComponent(goodsItem.name)
        });
        window.VhallDataAgent.track('button_click_response', {
          button_type: 'popup_click',
          button_url: goodsItem.goods_url,
          goods_id: goodsItem.goods_id,
          goods_name: encodeURIComponent(goodsItem.name)
        });
        // 事件通知
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitShowDetail', [data.goods_id])
        );
      },
      handleBuy(good) {
        // 数据埋点
        window.vhallReportForWatch?.report(170030, {
          goods_id: good.goods_id,
          goods_name: encodeURIComponent(good.name)
        });
        window.VhallDataAgent.track('button_click_response', {
          button_type: 'popup_buy',
          button_url: good.goods_url,
          goods_id: good.goods_id,
          goods_name: encodeURIComponent(good.name)
        });
        if (isWxMini() && good.buy_type != 4 && good.buy_type != 1) {
          // 小程序环境，购买方式不是小程序购买统一提示
          this.$vhMessage.warning(this.$t('host.k_605001'));
          return;
        }
        if (good.buy_type == 2) {
          let url = good.url;
          if (this.isEmbed) {
            //完全嵌入 补充商品query
            let querys = this.$route.query;
            for (const key in querys) {
              if (Object.hasOwnProperty.call(querys, key) && key.startsWith('customer_goods_')) {
                const element = querys[key];
                const indexOfSeparator = url.indexOf('?');
                if (typeof element == 'string') {
                  if (indexOfSeparator > -1) {
                    url += `&${key}=${element}`;
                  } else {
                    url += `?${key}=${element}`;
                  }
                } else {
                  //多个重名的key
                  element.map(e => {
                    if (indexOfSeparator > -1) {
                      url += `&${key}=${e}`;
                    } else {
                      url += `?${key}=${e}`;
                    }
                  });
                }
              }
            }
          }

          /**
           * 微吼配置链接：
           * 中间页https://bpvhall.isv-dev.youzan.com/custom-page/client/packages/bpvhall/loading/index?kdt_id=161395411
           * ?liveId=789012&liveUrl=https%3A%2F%2Fwww.example.com%2FliveRoom&targetUrl=https%3A%2F%2Fwww.example.com%2Fyouzan&iframeUrl=https%3A%2F%2Fwww.example.com%2Fh5Page
           * 参数解析:
           * 中间页url: 域名和kdt_id分为: 测试环境和生产环境 当前为测试环境
           * liveId: 直播间Id,订单关联直播间id(微吼销量和退单信息)
           * liveUrl:直播间url,返回直播间操作(对参数进行urlencode编码处理)
           * targetUrl: 跳转进入有赞商城进行浏览商品及下单操作(对参数进行            urlencode编码处理)
           * iframeUrl : 有赞商城iframe嵌套播放地址(对参数进行urlencode编码处理
           * phone：有赞根据手机号保存用户与直播间的关系
           * )
           * @type {string}
           */
          let newUrl = url;

          if (this.middleUrl) {
            let opt = {
              liveUrl: this.webinarUrl, // 当前商品所在活动地址
              liveId: this.webinarId,
              iframeUrl: this.embedClientVideoUrl // 第三方单视频嵌入地址
            };
            if (this.phone) {
              opt.phone = this.phone;
            }
            opt.targetUrl = url;
            newUrl = addParamsToUrl(this.middleUrl, opt);
          }

          openHref(newUrl);
        } else if (good.buy_type == 4) {
          if (isWxMini() && 'wx' in window && good?.mini_program_config?.mini_program_path) {
            const url = appendQueryParamsToPath(good.mini_program_config.mini_program_path, {
              webinarId: this.webinarId
            });
            if (!wx.miniProgram) return;
            const toMiniprogramWay = this.permissionValueObj?.['goods_to_miniprogram_way'] || '';
            if (toMiniprogramWay && typeof wx.miniProgram[toMiniprogramWay] === 'function') {
              wx.miniProgram[toMiniprogramWay]({ url });
            } else {
              wx.miniProgram.redirectTo({ url });
            }
          } else if (isWechat() && !isWxMini() && good?.mini_program_config?.mini_program_id) {
            return;
          } else {
            this.$vhMessage.warning(this.$t('host.k_605002'));
          }
        } else if (good.buy_type == 1 || good.buy_type == 3) {
          if (good.buy_type == 3 && this.$route.query.p_source != 4 && !good.qr_code_url) {
            this.$vhMessage.warning(this.$t('host.k_605003'));
            return;
          }
          // 事件通知
          window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenOrder', [good]));
        }
      },
      // 更新商品
      updateGoodsList(data) {
        this.$refs.productList.queryGoodsListJson(data, data.data.action);
      },
      addPushMsg(e) {
        if (e.data.push_status == 2) return;
        const data = {
          nickname: e.data.pusher_nickname,
          avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
          content: {
            text_content: `${this.$t('chat.chat_1099')} ${this.$t('menu.menu_1004')}`,
            goods_id: e.data.goods_id,
            goods_name: e.data.goods_name
          },
          type: e.data.type,
          roleName: e.data.role_name,
          interactStatus: true,
          isCheck: !!this.isWatch
        };
        useChatServer().addChatToList(data);
      },
      // 是否显示商品tab
      showProductVisible(flag) {
        console.log(flag, '???!2344');
        // 开启自定义菜单
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitShowGoodsTab', [{ visible: flag, type: 5 }])
        );
      }
    }
  };
</script>
<style lang="less" scoped>
  .vmp-product {
    margin: 16px auto;
    height: calc(100% - 32px);
    ::-webkit-scrollbar-thumb {
      background-color: #666;
    }
    &-send {
      height: calc(100% - 32px);
      ::v-deep .goods-wrapper {
        align-content: flex-start;
        overflow-x: hidden;
        .goods-item {
          padding-left: 16px;
          padding-right: 10px;
          width: 277px;
          .goods-info_text {
            width: calc(100% - 88px);
          }
          .price-info {
            .discount_price .price {
              font-size: 14px;
            }
            .price-tip {
              margin-right: 1px;
            }
            .original_price {
              padding-left: 3px;
              .price {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>
